import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const GET_NUDITY_DATA = `${API_URL}/api/v1/parent/activity`;
export const DELETE_NUDITY = `${API_URL}/api/v1/parent/delete-activity`;


export function getNudityData(payload) {
  return axiosInstance({
    url: GET_NUDITY_DATA,
    method: "GET",
    params: payload,
  });
}

export function deleteNudity(payload) {
  return axiosInstance({
    url: DELETE_NUDITY,
    method: "POST",
    data: payload,
  });
}
